import { render, staticRenderFns } from "./UserRoleItemPushes.vue?vue&type=template&id=e2c6899c&scoped=true"
import script from "./UserRoleItemPushes.vue?vue&type=script&lang=js"
export * from "./UserRoleItemPushes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.8_css-loader@6.11.0_webpack@5.95.0__lodash@4.17.21_p_7bbov6wcybt3565tdcixgihtju/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c6899c",
  null
  
)

export default component.exports